<template>

<com-item name="collection.head" :size="size" :is-container="true">

	<template v-slot:stats>

        <div class="head">

            <div class="head-level is-current">

                <div class="head-level-value">{{ data.current.hindex }}<small>Current</small></div>

                <div class="summary-change-items">

					<div class="summary-change-item">

						<div class="summary-change-item-value"><core-date theme="white" :date="data.current.date" /></div>
						<div class="summary-change-item-text">Date<br/>Reached</div>
						
					</div>

					<div class="summary-change-item">

						<div class="summary-change-item-value">{{ data.current.games }}</div>
						<div class="summary-change-item-text">Games<br/>Played</div>
						
					</div>

					<div class="summary-change-item">

						<div class="summary-change-item-value">{{ data.current.plays }}</div>
						<div class="summary-change-item-text">Total<br/>Plays</div>
						
					</div>

				</div>

            </div>

            <div class="head-level is-next">

                <div ref="progress" class="head-level-progress">

                    <div class="head-level-value">{{ data.current.hindex + 1 }}<small>Next</small></div>

                </div>

                <div class="summary-change-items">

					<div class="summary-change-item">

						<div class="summary-change-item-value">{{ data.next.days }}</div>
						<div class="summary-change-item-text">Days<br/>So Far</div>
						
					</div>

					<div class="summary-change-item">

						<div class="summary-change-item-value">{{ data.next.games }}</div>
						<div class="summary-change-item-text">Games<br/>Required</div>
						
					</div>

					<div class="summary-change-item">

						<div class="summary-change-item-value">{{ data.next.plays }}</div>
						<div class="summary-change-item-text">Min. Plays<br/>Needed</div>
						
					</div>

				</div>

            </div>

        </div>

	</template>

</com-item>

</template>

<script>

import ProgressBar from 'progressbar.js'

import comItem from './../common/Item'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem
	},

    data: function() {

        return {
            progress: false
        }

    },

	computed: {

		loading: function() {

			return this.fetching === 'all' 

		},

		data: function() {

			return this.$store.getters['page/insights/hindex/summary']

		},

		active: function() {

			return this.data && !this.loading

		}

	},

	mounted: function() {

		this.progress = new ProgressBar.Circle(this.$refs.progress, {
			strokeWidth: 6,
			color: '#4881bb',
			trailColor: '#d0e8f0',
			trailWidth: 2,
			duration: 2000,
			easing: 'easeInOut',
			svgStyle: {
				position: 'absolute',
				left: '0px',
				top: '0px'
			}
		})

		var percent = (1 / 100) * this.data.next.progress

		percent = (percent > 100) ? 100 : percent

		this.progress.animate(percent)

	}

}

</script>

<style scoped>

.head {
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 100%;
    height: 100%;
}

.is-mobile .head {
	grid-template-columns: 1fr;
}

.head-level {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 20px;
    align-items: center;
}

.head-level.is-current {
    background-color: #4881bb;
    border-radius: 4px 0px 0px 4px;
    z-index: 2;
}

.is-mobile .head-level.is-current {
    border-radius: 4px 4px 0px 0px;
	height: 320px;
}

.head-level.is-next {
    background-color: #fff;
    border-radius: 0px 4px 4px 0px;
    border: 1px solid #ddd;
}

.is-mobile .head-level.is-next {
    border-radius: 0px 0px 4px 4px;
	height: 320px;
}

.head-level.is-current:before {
    content: '';
    display: block;
    width: 0px;
    height: 0px;
    border-style: solid;
    border-width: 32px 0 32px 32px;
    border-color: transparent transparent transparent #4881bb;
    transform: rotate(0deg);
    position: absolute;
    right: -16px;
    top: 50%;
    margin-top: -76px;
}

.is-mobile .head-level.is-current:before {
    border-width: 32px 32px 0 32px;
    border-color: #4881bb transparent transparent transparent;
    top: 100%;
	right: 50%;
	margin-right: -32px;
	margin-top: -16px;
}

.head-level-progress {
    width: 160px;
    height: 160px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.head-level-value {
    font-size: 80px;
    font-weight: 700;
    width: 160px;
    height: 160px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
}

.head-level-value small {
    display: block;
    font-size: 16px;
    font-weight: 400;
}

.head-level.is-current .head-level-value {
    color: #fff;
}

.head-level.is-next .head-level-value {
    color: #4881bb;
}

.summary-change-items {
	display: flex;
	flex-direction: row;
	justify-content: center;
	width: 100%;
    margin-top: 20px;
}

.summary-change-item {
	width: 33.3%;
	display: flex;
	flex-direction: column;
}

.summary-change-item-value {
	align-items: center;
	display: flex;
	color: #fff;
	height: 48px;
	font-weight: 500;
	font-size: 28px;
	justify-content: center;
}

.head-level.is-next .summary-change-item-value {
    color: #4881bb;
}

.summary-change-item-value > div {
	height: 64px;
	display: flex;
	align-items: center;
}

.summary-change-item-text {
	height: 16px;
	flex-shrink: 0;
	color: #fff;
    line-height: 14px;
	font-size: 12px;
	text-align: center;
	font-weight: 400;
}

.head-level.is-next .summary-change-item-text {
    color: #4881bb;
}

</style>